import React from 'react'
import { useTranslation } from 'react-i18next'
import TableMain from '../../components/Common/table/TableMain';
import { ApiHook } from '../../hooks/apiHook';
import { toast } from 'react-toastify'
import { getLastPage } from '../../utils/getLastPage';
import { useQueryClient } from "@tanstack/react-query";

function SubscriptionReport(props) {
    console.log(props?.data?.data?.totalEntries)
    const { t } = useTranslation()
    const queryClient = useQueryClient();
    const reportHeaders = [
        t("invoice_no"),
        t("Package"),
        t("totalAmount"),
        t("paymentMethod"),
        t("purchaseDate"),
        t("status"),
        t('action')
    ];
    const refund = ApiHook.CallrefundRequest()

    const refundHandler = async (subscriptionDetail) => {
        const data = {
            type: 'renewal',
            extendHistoryId: subscriptionDetail?.id,
            paymentMethods: JSON.stringify([{ "payment_method": subscriptionDetail?.payment_id, "amount": subscriptionDetail?.amount, "name": subscriptionDetail?.payment_method }]),
            status: 0,
            totalAmount: subscriptionDetail?.amount
        }
        const response = await refund.mutateAsync(data)
        if (response.status) {
            queryClient.invalidateQueries({
                queryKey: ["subscription-report", props.currentPage, props.itemsPerPage],
            });
            toast.success(t('refund_request_added'))
        } else {
            toast.error(t(response.description))
        }

    }
    // const cancelSubscription = async (data) => {

    // }
    const lastPage = getLastPage(props.itemsPerPage, props?.data?.data?.totalEntries);
    console.log("==props.data?.data===", props.data)
    return (
        <div className="ewallet_table_section">
            <div className="ewallet_table_section_cnt">
                <div className="table-responsive min-hieght-table">
                    <TableMain
                        headers={reportHeaders}
                        data={props.data?.data?.updatedData}
                        startPage={1}
                        currentPage={props.currentPage}
                        totalPages={lastPage}
                        type={props.type}
                        itemsPerPage={props.itemsPerPage}
                        setItemsPerPage={props.setItemsPerPage}
                        setCurrentPage={props.setCurrentPage}
                        setEpinSortOptions={props.setSortOptions}
                        refundHandler={refundHandler}
                    />
                </div>
            </div>
        </div>
    )
}

export default SubscriptionReport